export const REF_PARAM_NAME = 'ref'
// Routes where ref should NOT be added
export const EXCLUDE_ROUTES = ['/api', '/admin', '/_next']
